import script from "./ExcavatorOperation.vue?vue&type=script&setup=true&lang=js"
export * from "./ExcavatorOperation.vue?vue&type=script&setup=true&lang=js"

import "./ExcavatorOperation.vue?vue&type=style&index=0&id=87b3b264&lang=scss"

const __exports__ = script;

export default __exports__